import store from "../store";
import * as ActionType from "./contant";

export default {
  setNoticeBoard: (value) => {
    const action = { type: ActionType.SET_NOTICEBOARD, value };
    store.dispatch(action);
  },
  clearNoticeBoard: () => {
    const action = { type: ActionType.CLEAR_NOTICEBOARD };
    store.dispatch(action);
  },
};
